<template>
  <v-row align-content="center" class="">
    <v-col class="py-0 mx-auto" md="10" style="min-height: 100vh;">
      <v-row>
        <v-col v-show="send" class="mx-auto" md="6">
          <v-spacer class="py-10"></v-spacer>
          <div class="mx-auto text-center">            
            <img src="@/assets/images/img-logo-black.png" class="mb-5">          
          </div>
          <v-form
            ref="form"
            class="px-8 white rounded"
            @submit.prevent="submit"
            v-model="valid"            
          > 
            <div class="mx-auto text-center mb-3 text-black py-3">
              <p class="font-weight-bold title-login">Reset Password</p>
            </div>
            <v-row>
              <v-col cols="12" class="py-0 text-center">
                <p class="text-muted">Enter the email address associated with your account, and we'll send you a link to reset your password.</p>
              </v-col>
            </v-row>
            <v-alert
              class="mt-2"
                type="error"
                text
                dense
                prominent
                v-show="response !== null"
                >{{ response }}</v-alert
              >          
            <v-row>
              <v-col class="">
                <div class="subtitle-2 mb-2 text-black mt-1">Email</div>
                <v-text-field
                  filled
                  v-model="email"
                  :rules="[...rules('Email', 'required'), validate]"
                  required
                  outlined
                  hide-details="auto"
                ></v-text-field>
              </v-col>
            </v-row>
            
            <v-row>
              <v-col cols="12" class="">
                <v-btn
                  large
                  elevation="0"
                  type="submit"
                  color="primary"
                  :loading="submiting"
                  block
                >
                  Continue
                </v-btn>
                
              </v-col>
              <v-col cols="12" class="text-center">
                <router-link
                  class="font-weight-medium text-decoration-none"
                  tabindex="-1"
                  color="primary"
                  :to="{ name: 'login' }"
                >
                  Return to sign in
                </router-link>
              </v-col>              
            </v-row>
          </v-form>
          <v-spacer class="py-8"></v-spacer>
          <v-row>
            <v-col cols="12" class="text-center">
              <span class="text-black">
                Don't have an account?    
              <router-link
                class="font-weight-medium text-decoration-none"
                tabindex="-1"
                color="primary"
                :to="{ name: 'registration' }"
              >
                Sign up
              </router-link>
              </span>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-show="cekEmail" class="mx-auto" md="6">
          <v-spacer class="py-10"></v-spacer>
          <div class="mx-auto text-center">            
            <img src="@/assets/images/img-logo-black.png" class="mb-5">          
          </div>
          <div
            class="px-8 white rounded"           
          > 
            <div class="mx-auto text-center mb-3 py-3">
              <p class="text-muted">Please check your email that you registered for this username. An email will only be sent to a valid email address from the registered username.</p>            
            </div>                      
          </div>          
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import validationMixin from "../_mixins/validation";

export default {
  mixins: [validationMixin],
  name: "login",
  data() {
    return {
      valid: true,
      errors: null,
      send:true,
      cekEmail:false,
      email: "",
      password: "",
      checkbox: false,
      submiting: false,
      show:false,
      response:null
    };
  },
  computed: {
    validate() {
      return !this.errors || this.errors.message;
    },
  },
  methods: {
    submit() {      
      setTimeout(() => {
      if (this.$refs.form.validate()) {
        this.submiting = true;
        let data = { email:this.email};

        this.axios
          .post(
            `auth/users/forgot_password`,data,
            {
              headers: {"Content-Type": "application/json"},
            })
          .then(() => {
            this.submiting = false;            
            this.cekEmail=true;
            this.send=false;
          })
          .catch((error) => {
            this.submiting = false;
            this.$refs.form.reset();
            // console.log('er',error.response)            
            this.response = error.response.data.message;
            setTimeout( () => {                
              this.response=null;
            }
            , 3000);
          });
        } 
      }, 50);
    },
  },
};
</script>

<style>
</style>